<template>

  <div class="min-h-screen flex flex-col justify-between">    
    <div class="flex flex-col flex-1 items-center justify-center -mt-36">
      <div class="bg-white rounded-xl shadow-md p-5 w-11/12 md:w-8/12 lg:w-5/12 xl:w-4/12 2xl:w-3/12">

        <div class="flex justify-center items-center">
          <a class="text-center" href="/">
            <img src="@/assets/img/logo.png" class="p-2.5 w-24 h-auto" />
          </a>
        </div>

        <div class="w-full flex flex-col my-4 text-center">
          <div class="text-lg md:text-2xl">{{ $t('global.atencion') }}</div>
          <div class="text-lg md:text-2xl">{{ $t('errors.pagina.no.encontrada') }}</div>
        </div>

        <div class="w-full flex flex-col my-4 items-center mt-16">
        <button @click="volver" class="w-full md:w-7/12 lg:w-8/12 text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
          VOLVER
        </button>
        </div>

      </div>
    </div>
  </div>

</template>

<script lang="ts">
export default {
  methods: {
    volver() {
      window.history.back();    
    }
  }
}
</script>
